module.exports = __webpack_public_path__ + "img/rw_logo.1aa3b259a8068a6243f5bf61394db9ec.svg";